import { trackReportGeneration, trackAdminReportGeneration } from '../../Telemetry/Mixpanel/Features/analyticsTracker';
export const GENERATE_REPORT_STARTED = 'GENERATE_REPORT_STARTED';
export const GENERATE_REPORT_SUBMITTED = 'GENERATE_REPORT_SUBMITTED';
export const GENERATE_REPORT_COMPLETED = 'GENERATE_REPORT_COMPLETED';
export const GENERATE_REPORT_FAILED = 'GENERATE_REPORT_FAILED';
export const GENERATE_REPORT_DELAYED = 'GENERATE_REPORT_DELAYED';
export const GENERATE_EMAIL_REPORT = 'GENERATE_EMAIL_REPORT';

export const GENERATE_REPORT_TRIGGER_PAUSED = 'GENERATE_REPORT_TRIGGER_PAUSED';
export const GENERATE_REPORT_PAUSED = 'GENERATE_REPORT_PAUSED';
export const GENERATE_REPORT_CANCELLED = 'GENERATE_REPORT_CANCELLED';
export const GENERATE_REPORT_RESUMED = 'GENERATE_REPORT_RESUMED';
export const GENERATE_REPORT_MODAL_TOGGLE = 'GENERATE_REPORT_MODAL_TOGGLE';

export function submitReportGenerationJob(
  reportType,
  reportFormatType,
  keys,
  user,
  sendEmail = false,
  isAdmin = false
) {
  if (isAdmin) {
    trackAdminReportGeneration(reportType, reportFormatType, keys, sendEmail);
  }
  trackReportGeneration(reportType, reportFormatType);
  return {
    type: GENERATE_REPORT_STARTED,
    payload: { reportType, reportFormatType, keys, user, sendEmail }
  };
}

export function pauseDownload() {
  return {
    type: GENERATE_REPORT_TRIGGER_PAUSED
  };
}

export function cancelDownload() {
  return {
    type: GENERATE_REPORT_CANCELLED
  };
}

export function resumeDownload() {
  return {
    type: GENERATE_REPORT_RESUMED
  };
}

export function toggleGenerateReportModal() {
  return {
    type: GENERATE_REPORT_MODAL_TOGGLE
  };
}

export function sendReportByEmail() {
  return {
    type: GENERATE_EMAIL_REPORT
  };
}

export class ReportStatus {
  static get STARTED() {
    return 'STARTED';
  }

  static get SUBMITTED() {
    return 'SUBMITTED';
  }

  static get COMPLETED() {
    return 'COMPLETED';
  }

  static get FAILED() {
    return 'FAILED';
  }

  static get DELAYED() {
    return 'DELAYED';
  }

  static get PAUSED() {
    return 'PAUSED';
  }

  static get FETCHING() {
    return 'FETCHING';
  }
}



// WEBPACK FOOTER //
// ./src/Reducks/Reports/ReportsActions.js